// actions/UserActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";

// export const createUser = (data) => async (dispatch) => {
//   dispatch({ type: CREATE_USER_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const response = await axios.post(`${BASE_URL}/v1/api/create-user`, data, {
//       headers: {
//         Authorization: token,
//         "Content-Type": "application/json",
//       },
//     });

//     dispatch({ type: CREATE_USER_SUCCESS, payload: response.data });
//     toast.success("User created successfully!");
//   } catch (error) {
//     dispatch({ type: CREATE_USER_FAILURE, payload: error.response?.data?.message || error.message });
//     toast.error("Failed to create user");
//   }
// };


export const createUser = (data) => async (dispatch) => {
  dispatch({ type: CREATE_USER_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/create-user`, data, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    const result = response.data;

    if (!result.meta?.status) {
      dispatch({ type: CREATE_USER_FAILURE, payload: result.meta?.message || "Failed to create user" });
      toast.error(result.meta?.message || "Failed to create user");
      return;
    }

    dispatch({ type: CREATE_USER_SUCCESS, payload: result });
    toast.success("User created successfully!");
  } catch (error) {
    const message = error?.response?.data?.meta?.message || error.message;
    dispatch({ type: CREATE_USER_FAILURE, payload: message });
    toast.error(message);
  }
};
